import request from '@/utils/request';
const path = 'tool/microGame/jrtt';

/**
 * 获取字节小游戏列表
 * @param {Object} params 接口参数
 */
export function getMicroGameListApi(params) {
  return request({
    url: `/${path}`,
    method: 'get',
    params,
  });
}

/**
 * 同步字节小游戏列表
 * @param {Object} params 接口参数
 */
export function pullMicroGameListApi(params) {
  return request({
    url: `/${path}/pull`,
    method: 'get',
    params,
  });
}
